module.exports = __webpack_public_path__ + "img/Je-soutiens-mon-commerce-ok.061b9542.png";